import { Flame, Star, TrendingUp } from "lucide-react";
import { Link } from "react-router-dom";
import { fmt } from "../lib/api";

export const ProductCard = ({ product }) => (
  <Link
    to={`/product/${product.id}`}
    data-testid={`product-card-${product.id}`}
    className="card-surface group block overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-amber-400/40 hover:shadow-[0_20px_50px_-20px_rgba(234,179,8,0.25)]"
  >
    <div className="relative aspect-square overflow-hidden bg-[#0A0A0C]">
      <img
        src={product.images?.[0]}
        alt={product.name}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      <div className="absolute left-3 top-3 flex flex-col gap-1.5">
        {product.badges?.includes("trending") && (
          <span className="flex items-center gap-1 rounded-full bg-sky-400/90 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-black">
            <TrendingUp size={11} /> Trending
          </span>
        )}
        {product.badges?.includes("bestseller") && (
          <span className="flex items-center gap-1 rounded-full bg-amber-400 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-black">
            <Flame size={11} /> Bestseller
          </span>
        )}
        {product.badges?.includes("final_sale") && (
          <span className="rounded-full bg-rose-500/90 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-white">
            Final sale
          </span>
        )}
      </div>
    </div>
    <div className="p-4">
      <p className="text-[11px] font-mono uppercase tracking-widest text-slate-500">{product.category}</p>
      <h3 className="mt-1 line-clamp-1 font-heading text-base font-semibold text-white">{product.name}</h3>
      <div className="mt-1.5 flex items-center gap-1 text-xs text-slate-400">
        <Star size={12} className="fill-amber-400 text-amber-400" />
        {product.rating} <span className="text-slate-600">({product.reviews})</span>
        <span className="ml-auto text-emerald-400">{product.sold_count?.toLocaleString()} sold</span>
      </div>
      <div className="mt-2 flex items-baseline gap-2">
        <span className="font-heading text-lg font-bold text-white" data-testid={`product-price-${product.id}`}>
          {fmt(product.price)}
        </span>
        <span className="text-xs text-slate-600 line-through">{fmt(product.price * 1.45)}</span>
      </div>
    </div>
  </Link>
);
